var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHowItWorksCol1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19134_32549)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9427 15.4167C19.1999 15.4167 22.651 11.9655 22.651 7.70833C22.651 3.45114 19.1999 0 14.9427 0C10.6855 0 7.23438 3.45114 7.23438 7.70833C7.23438 11.9655 10.6855 15.4167 14.9427 15.4167Z",
    fill: "#DE5F28",
    fillOpacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4271 27.6462C33.6843 27.6462 37.1354 24.195 37.1354 19.9378C37.1354 15.6806 33.6843 12.2295 29.4271 12.2295C25.1699 12.2295 21.7188 15.6806 21.7188 19.9378C21.7188 24.195 25.1699 27.6462 29.4271 27.6462Z",
    fill: "#DE5F28",
    fillOpacity: 0.12
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2904 33.9167C15.5476 33.9167 18.9987 30.4655 18.9987 26.2083C18.9987 21.9511 15.5476 18.5 11.2904 18.5C7.03317 18.5 3.58203 21.9511 3.58203 26.2083C3.58203 30.4655 7.03317 33.9167 11.2904 33.9167Z",
    fill: "#DE5F28"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19134_32549"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37,
    height: 37,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowItWorksCol1);
export default __webpack_public_path__ + "static/media/how-it-works-col-1.13687c84423aee80d74bd1ae77203817.svg";
export { ForwardRef as ReactComponent };